import { Grid, Typography } from '@mui/material'
import { CarrierVisitDirection } from '@planning/app/api'
import { useTranslate } from '@tolgee/react'
import { observer } from 'mobx-react-lite'

export interface DashboardStatusField {
  label?: string
  value?: number | null
}

interface Props {
  expected: DashboardStatusField
  onTerminal: DashboardStatusField
  offTerminal: DashboardStatusField
  direction?: CarrierVisitDirection | 'Restow'
}
export const VisitOrdersStatusText = observer(
  ({ expected, onTerminal, offTerminal, direction }: Props) => {
    const { t } = useTranslate()

    return (
      <Grid container spacing={2} alignItems='center'>
        <Grid size={4}>
          <Typography variant='subtitle2' color='secondary'>
            {expected.label ?? t('expected', 'Expected')}
          </Typography>
          <Typography variant='h3' data-cy={`visit-${direction}-expected-value`}>
            {expected.value}
          </Typography>
        </Grid>
        <Grid size={4}>
          <Typography variant='subtitle2' color='secondary'>
            {onTerminal.label ?? t('onTerminal', 'On terminal')}
          </Typography>
          <Typography variant='h3' data-cy={`visit-${direction}-on-terminal-value`}>
            {onTerminal.value}
          </Typography>
        </Grid>
        <Grid size={4}>
          <Typography variant='subtitle2' color='secondary'>
            {offTerminal.label ?? t('offTerminal', 'Off terminal')}
          </Typography>
          <Typography variant='h3' data-cy={`visit-${direction}-off-terminal-value`}>
            {offTerminal.value}
          </Typography>
        </Grid>
      </Grid>
    )
  },
)
